import { FontInfo } from '@/hooks/use-load-fonts/typings';

const font: FontInfo = {
	name: 'ascender-bold-italic',
	weight: '700',
	style: 'italic',
	css: (remoteUrl?: string) => `@font-face {
        font-family: 'ascender-bold-italic';
        src: url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic.eot');
        src: url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic?#iefix') format('embedded-opentype'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic.woff2') format('woff2'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic.woff') format('woff'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic.ttf') format('truetype'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/Ascender/AscenderSerifW05-BoldItalic.svg#ascender') format('svg');
        font-style: italic;
        font-weight: bold;
        font-display: swap;
    }`,
};

export default font;
